import type { StatusPillTone } from '../Common'

/** Maps an analysis health state (HEALTHY / WATCH / CRITICAL) to a StatusChip tone. */
export const analysisHealthTone = (state: string): Extract<StatusPillTone, 'success' | 'warning' | 'danger' | 'neutral'> => {
  const s = state.toUpperCase()
  if (s === 'HEALTHY') return 'success'
  if (s === 'WATCH') return 'warning'
  if (s === 'CRITICAL') return 'danger'
  return 'neutral'
}
